module.exports = __webpack_public_path__ + "img/39.6bdde7ad.jpg";